/**
 * Specra Assist write rule (FND-27 AWR-4/AWR-5): the labels a browser-applied
 * Assist proposal sends with its writes, and the attribution text history rows
 * show. The headers are metadata only; no server check allows or denies on them.
 */ /** WriteAttribution.via for a write a human accepted from an Assist proposal. */ export const VIA_SPECRA_ASSIST = 'specra_assist';
/** Headers for a write the human accepted from saved proposal conversationId:toolCallId. */ export function assistWriteHeaders(conversationId, toolCallId) {
    return {
        'X-Specra-Via': 'assist',
        'X-Specra-Assist-Run': `${conversationId}:${toolCallId}`
    };
}
/** "<approver> via Specra Assist" for an Assist-accepted write, else the approver. */ export function formatAssistAttribution(approver, via) {
    return via === VIA_SPECRA_ASSIST ? `${approver} via Specra Assist` : approver;
}
